const browser = {
	init() {
		window.browser = this.getBrowser()
	},

	getBrowser() {
		const ua = navigator.userAgent

		// Check for Firefox
		if (ua.indexOf('Firefox') > -1) {
			return 'Firefox'
		}

		// Check for Chrome (make sure it's not Edge or Opera which also include "Chrome" in their UA)
		if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edge') === -1 && ua.indexOf('OPR') === -1) {
			return 'Chrome'
		}

		// Check for Safari (exclude Chrome since its UA also includes "Safari")
		if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
			return 'Safari'
		}

		return 'Other'
	},
}

export default browser
